import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_DEVELOPER_TOKEN_CREATE = "REQUEST_DEVELOPER_TOKEN_CREATE";
export const doREQUEST_DEVELOPER_TOKEN_CREATE = createDoRequestAction(
  REQUEST_DEVELOPER_TOKEN_CREATE,
);

export const requestDeveloperTokenCreateActionCreators = {
  doREQUEST_DEVELOPER_TOKEN_CREATE,
};

export function* requestDeveloperTokenCreate({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestDeveloperTokenCreate");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        name: v.string().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { name } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/developer-token-create`,
    accessToken,
    data: {
      name,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/developer-token-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_DEVELOPER_TOKEN_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* developerTokenCreateSaga() {
  yield takeEvery(REQUEST_DEVELOPER_TOKEN_CREATE as any, requestDeveloperTokenCreate);
}
